
export const JOB_DUTIES_BY_OCCUPATION: { [key: number]: string[] } = {
    // キッチン系（料理長は別途定義）
    4: [ // キッチンスタッフ
        'メインメニュー調理',
        'アラカルト調理',
        '盛り付け・仕上げ',
        '肉の下処理・仕込み',
        '魚の下処理・仕込み',
        '野菜の下処理・仕込み',
        '衛生管理・厨房清掃',
        '発注・在庫管理',
        '原価管理',
        'メニュー開発',
        'スタッフ教育・新人指導',
        'シフト管理',
    ],
    // ホール系
    3: [ // レストランサービス・ホールスタッフ
        '接客・サービス業務',
        'ドリンク作成',
        'レセプション',
        '予約管理',
        '会計・精算業務',
        '顧客対応・クレーム対応',
        'スタッフ育成・指導',
        'フロアレイアウト・セッティング管理',
        'イベント・宴会サービス対応',
        '発注・在庫管理',
        '原価管理',
        'シフト管理',
    ],
    18: [ // レセプション・レストランレセプション
        '接客・サービス業務',
        'ドリンク作成',
        'レセプション',
        '予約管理',
        '会計・精算業務',
        '顧客対応・クレーム対応',
        'スタッフ育成・指導',
        'フロアレイアウト・セッティング管理',
        'イベント・宴会サービス対応',
        '発注・在庫管理',
        '原価管理',
        'シフト管理',
    ],
    26: [ // 女将・和装ホール
        '接客・サービス業務',
        'ドリンク作成',
        'レセプション',
        '予約管理',
        '会計・精算業務',
        '顧客対応・クレーム対応',
        'スタッフ育成・指導',
        'フロアレイアウト・セッティング管理',
        'イベント・宴会サービス対応',
        '発注・在庫管理',
        '原価管理',
        'シフト管理',
    ],
    // 店長
    1: [ // 店長・店長候補
        '店舗運営全般',
        'FL管理',
        'PL管理',
        'アルバイト採用',
        '社員採用',
        'スタッフ育成・指導',
        'シフト管理・労務管理',
        '発注・在庫管理',
        '原価管理',
        '顧客対応・クレーム対応',
        '店舗売上分析・改善施策立案',
        'PR企画',
        '新規出店・リニューアル対応',
    ],
    // 料理長
    2: [ // 料理長・料理長候補
        '調理業務全般',
        'メニュー開発・レシピ作成',
        '発注・在庫管理',
        '原価管理',
        'FL管理',
        'PL管理',
        'アルバイト採用',
        '社員採用',
        'スタッフ育成・指導',
        'コース料理・宴会料理対応',
        '顧客対応・クレーム対応',
        '新規出店・リニューアル対応',
    ],
    // パティシエ
    11: [ // パティシエ
        '焼菓子の製造',
        '洋菓子の製造',
        'デセール',
        '生地・クリームの仕込み',
        'テンパリング',
        'ナッペ',
        'アイシング',
        '成形',
        '焼成',
        '仕上げ',
        '盛り付け・デコレーション',
        '新作・季節メニュー開発',
        '発注・在庫管理',
        '衛生管理・安全管理',
        'スタッフ育成・指導',
        '接客・サービス業務',
        'ウェディングケーキ製造',
    ],
    // ブーランジェ
    12: [ // ブーランジェ・ベーカー
        'オールスクラッチ',
        '冷凍生地',
        '仕込み',
        '折り込み',
        '成形',
        '焼成',
        '仕上げ',
        'ハードパンの製造',
        '温度管理',
        '発酵管理',
        '衛生管理・安全管理',
        '新作・季節メニュー開発',
        'スタッフ育成・指導',
        '接客・サービス業務',
        '商品ディスプレイ',
    ],
}

// 汎用版（それ以外の選択肢）
export const DEFAULT_JOB_DUTIES = [
    '接客・サービス業務',
    'ドリンク・メニュー提供',
    '予約管理',
    '購買',
    '商品ディスプレイ',
    '商品開発',
    '衛生管理・安全管理',
    '顧客対応・クレーム対応',
    'スタッフ育成・教育',
    'シフト管理',
    'オペレーション管理',
    'PR企画',
    '事務',
    '人事',
    '経理',
    'マネジメント・統括業務',
    '飲食未経験',
]

export const CUSTOMER_SPEND = [
    '1,500円以下',
    '1,500〜5,000円',
    '5,000〜10,000円',
    '10,000〜15,000円',
    '15,000〜30,000円',
    '30,000円以上',
]

export const STORE_SIZE = [
    '20席未満',
    '20〜50席',
    '50〜100席',
    '100〜200席',
    '200席以上',
    '席なし',
]

export const LOADING_DELAY_MS = 1500

export const EMPLOYMENT_MAP: { [key: number]: string } = {
    1: '正社員',
    2: '契約社員',
    3: 'パート・アルバイト',
}
